import {
    AzureDataExplorerLinkedService,
    IModel,
    IAttribute,
    ParameterValue,
    format,
    ModelConstants
} from 'shell-models-lib';
import { Metamodel } from 'app/model/base/model';
import { Activity } from './activity';

@Metamodel.model({
    name: ModelConstants.azureDataExplorerCommandActivity,
    display: [
        format(stringResources.ModelName_ActivityTemplate, stringResources.AzureDataExplorerCommand_DisplayText),
        format(stringResources.ModelName_ActivitiesTemplate, stringResources.AzureDataExplorerCommand_DisplayText)
    ]
})
export class AzureDataExplorerCommandActivity extends Activity {
    public static readonly MODEL: IModel;
    public static readonly COMMAND: IAttribute;
    public static readonly COMMAND_TIMEOUT: IAttribute;
    public static readonly LINKED_SERVICE_PARAMETERS: IAttribute;

    @Metamodel.attribute({
        display: stringResources.ModelName_Command,
        constraint: {
            required: true
        },
        association: 'COMMAND',
        templatable: true
    })
    public command?: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_CommandTimeout,
        association: 'COMMAND_TIMEOUT',
        constraint: {
            pattern: new RegExp('^(\\d+\\.)?((0?\\d)|(1\\d)|(2[0-3]))(:[0-5]?\\d){2}$')
        },
        templatable: true
    })
    public commandTimeout?: string = '00:20:00';

    @Metamodel.attribute({
        display: format(stringResources.ModelName_LinkedServiceTemplate, stringResources.AzureDataExplorer_DisplayText),
        constraint: {
            required: true
        },
        reference: true,
        type: AzureDataExplorerLinkedService.MODEL
    })
    public linkedService?: AzureDataExplorerLinkedService;

    @Metamodel.attribute({
        association: 'LINKED_SERVICE_PARAMETERS'
    })
    public linkedServiceParameters: ParameterValue[] = [];

    constructor(name?: string, description?: string) {
        super(name, description);
        this.activityType = 'ExecutionActivity';
    }
}
